import { ApplicationModel } from "./application.model";
import { GuestModel, LearnerUserModel, UserModel } from "./auth.model";

export interface LearnerApplicationSummary {
  id: string;
  applicationNo: string;
  status: string;
  learningId: string;
  associatedMedicalSchool: string;
  postgraduateTrainingProgram: string;
  PGYLevel: string;
  PEAPStartDate: string;
  PEAPEndDate: string;
  paid: boolean;
  familyMedicine: boolean;
  imgBursaryAcknowledgement: boolean;
  orientationId: string;
  imgBursaryVoidCheque: string;
  imgBursarySocialInsuranceNumber: string | null;
  imgBursaryTransitNumber: string | null;
  imgBursaryAccountNumber: string | null;
  imgBursaryInstitutionNumber: string | null;
  comSimId: string | null;
  userId: string;
  adminAssigned: string | null;
  photo: string;
  paymentReference: string;
  feeId: string;
  highSchool: string | null;
  highSchoolCountry: string | null;
  highSchoolState: string | null;
  residencyProgramLanguage: string | null;
  nacExamAttempts: number | null;
  mccqe1ExamAttempts: number | null;
  preferredName: string | null;
  foundationId: string;
  advancedId: string | null;
  type: string;
  schoolId: string;
  isTestApplication: boolean;
  agreeToWatchOrientationRecording: boolean;
  nacExamScore: number;
  howToReceiveT4A: string | null;
  t4AEmailAddress: string | null;
  streetAddress: string | null;
  unitNumber: string | null;
  city: string | null;
  province: string | null;
  postalCode: string | null;
  country: string | null;
  bankDetail: {
    id: string;
    applicationId: string;
    SIN: number;
    SINUpload: string;
    accountName: string;
    accountNumber: string;
    bursaryAcknowledgement: boolean;
    bursaryVoidCheque: string;
    institutionNumber: number;
    preferredEmail: string;
    transitNumber: number;
  } | null;
}

export interface LearnerAllRecordModel {
  id: string;
  firstName: string;
  lastName: string;
  preferredName: string | null;
  email: string;
  examTypes: string[];
  programNos: string;
  sponsored: string;
  role: string;
  applications: LearnerApplicationSummary[];
}

export interface UserStateModel {
  users: UserModel[];
  guests: GuestModel[];
  learners: LearnerRecordDTO[];
  allLearners: LearnerAllRecordModel[];
  schoolAdmins: UserModel[];
  usersCount: number;
  loading: LoadingUserState;
  error: any | null;
}

export interface SchoolAdminRequest {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  schoolId: string;
  role: string;
  office: string;
}

// export interface GuestModel {
//     _id: string | null;
//     user: UserModel | null;
//     id: string | null
// }


export enum LoadingUserState {
  loadingList = "loadingList",
  loadingAddUpdate = "loadingAddUpdate",
  loadingDelete = "loadingDelete",
  notLoading = "notLoading",
}

export interface LearnerRecordDTO {
  id: string;
  applicationId?: string;
  firstName: string;
  lastName: string;
  preferredName?: string;
  email: string;
  programNos?: string;
  sponsored?: string;
  applicationNo?: string;
  status?: string;
  associatedMedicalSchool?: string;
  postgraduateTrainingProgram?: string;
  PGYLevel?: string;
  PEAPStartDate?: string;
  PEAPEndDate?: string;
    orientationDate?: string;
  orientationTime?: string;
  familyMedicine?: string;
  SIN?: string;
  SINUploaded?: string;
  transitNumber?: string;
  accountNumber?: string;
  accountName?: string;
  institutionNumber?: number;
  bursaryVoidCheque?: string;
  bursaryAcknowledgement?: string;
}

export function mapToLearnerRecordDTO(learner: LearnerAllRecordModel): LearnerRecordDTO {
  const app = learner.applications?.[0];
  const bankDetail = app?.bankDetail;
  return {
    id: learner.id,
    applicationId: app?.id,
    firstName: learner.firstName,
    lastName: learner.lastName,
    preferredName: learner.preferredName ?? undefined,
    email: learner.email,
    programNos: learner.programNos,
    sponsored: learner.sponsored,
    applicationNo: app?.applicationNo,
    status: app?.status,
    associatedMedicalSchool: app?.associatedMedicalSchool,
    postgraduateTrainingProgram: app?.postgraduateTrainingProgram,
    PGYLevel: app?.PGYLevel,
    PEAPStartDate: app?.PEAPStartDate,
    PEAPEndDate: app?.PEAPEndDate,
    familyMedicine: app?.familyMedicine ? 'Yes' : (app?.familyMedicine === false ? 'No' : undefined),
    SIN: bankDetail?.SIN?.toString() || app?.imgBursarySocialInsuranceNumber || undefined,
    SINUploaded: bankDetail?.SINUpload || undefined,
    transitNumber: bankDetail?.transitNumber?.toString() || app?.imgBursaryTransitNumber || undefined,
    accountNumber: bankDetail?.accountNumber || app?.imgBursaryAccountNumber || undefined,
    accountName: bankDetail?.accountName || undefined,
    institutionNumber: bankDetail?.institutionNumber ?? (app?.imgBursaryInstitutionNumber ? Number(app.imgBursaryInstitutionNumber) : undefined),
    bursaryVoidCheque: bankDetail?.bursaryVoidCheque || app?.imgBursaryVoidCheque || undefined,
    bursaryAcknowledgement: bankDetail?.bursaryAcknowledgement != null ? String(bankDetail.bursaryAcknowledgement) : undefined,
  };
}
